/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createSelector } from 'reselect';

const tokensSelector = state => state.token.getTokens;
export const tokenOptionsSelector = createSelector(
  tokensSelector,
  (tokens) => {
    if (tokens.status !== 'success') { return []; }
    return tokens.data.list.map(t => ({ label: t.name, value: t.token }));
  });




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayProps/selectors.jsx